'use strict';
const angular = require('angular');

export class accountRequestButtonComponent {
  constructor($uibModal) {
    'ngInject';
    this.$uibModal = $uibModal;
  }

  openAccountRequestModal() {
    var that = this;
    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'accountRequest',
      backdrop: 'static', // Prevents the modal to close, when clicking in the background
      resolve: {
        config: function() {
          return {
            type: that.type,
            title: that.title,
            icon: that.icon
          }
        }
      }
    });
  }
}

export default angular.module('conduuApp.accountRequestButtonComponent', [])
  .component('accountRequestButton', {
    template: '<button class="btn btn-{{$ctrl.btnsize}} btn-{{$ctrl.color}}" ng-click="$ctrl.openAccountRequestModal()"><i class="fa fa-fw fa-{{$ctrl.icon}}"></i> {{$ctrl.title}}</button>',
    bindings: {
      type: '@',
      title: '@',
      icon: '@',
      color: '@',
      btnsize: '@'
    },
    controller: accountRequestButtonComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/account-request-button/account-request-button.component.js